import { useContext } from 'react';
import { Button, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAddressCard,
  faPenToSquare,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';

import PartnerShape from './PartnerShape';
import { TableContext } from '../../../components/Table/TableContext';

const statusColor = {
  Active: 'success',
  Registered: 'warning',
  Draft: 'info',
};

export default function PartnerRowItem({
  partner: { id, name, title, tierTitle, address, status },
}) {
  const { onClickEdit, onClickDelete, onClickView } = useContext(TableContext);

  const handleClickProfile = () => onClickView(id);
  const handleClickEdit = () => onClickEdit(id);
  const handleClickDelete = () => onClickDelete(id);

  return (
    <tr>
      <td>{name}</td>
      <td>{title}</td>
      <td>{tierTitle}</td>
      <td>{address?.city}</td>
      <td>{address?.state}</td>
      <td>{address?.country}</td>
      {/* <td>{partner.email}</td> */}
      <td>
        <Badge
          bg={statusColor[status] || 'success'}
          className="text-capitalize"
        >
          {status}
        </Badge>
      </td>
      <td>
        <div className="flex space-around space-between text-center">
          <Button
            className="p-1 text-dark"
            variant="link"
            type="button"
            title="Partner Profile"
            onClick={handleClickProfile}
            data-testid="Button-viewProfile"
            role='button'
            aria-label='Partner Profile'
          >
            <FontAwesomeIcon icon={faAddressCard} />
          </Button>
          <Button
            className="p-1 me-1 text-dark"
            variant="link"
            type="button"
            title="Edit Partner"
            onClick={handleClickEdit}
            data-testid="Button-editProfile"
            role='button'
            aria-label='Edit Partner'
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </Button>
          <Button
            className="p-1 text-dark"
            variant="link"
            type="button"
            title="Delete Partner"
            onClick={handleClickDelete}
            data-testid="Button-deleteProfile"
            role='button'
            aria-label='Delete Partner'
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </div>
      </td>
    </tr>
  );
}

PartnerRowItem.propTypes = {
  partner: PartnerShape,
};

PartnerRowItem.defaultProps = {
  partner: null,
};
